import { c as _c } from "react/compiler-runtime";
import { FC } from "react";
import { ApiLightDrop } from "@/generated/models/ApiLightDrop";
interface LightDropProps {
  readonly drop: ApiLightDrop;
}
const LightDrop: FC<LightDropProps> = () => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="tw-w-8 tw-h-8 tw-rounded-full tw-bg-iron-800" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-flex tw-items-center tw-gap-2">{t0}<div className="tw-flex tw-flex-col tw-gap-1"><div className="tw-w-24 tw-h-3 tw-rounded tw-bg-iron-800" /><div className="tw-w-16 tw-h-2 tw-rounded tw-bg-iron-800" /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="tw-flex tw-flex-col tw-gap-1"><div className="tw-w-full tw-h-3 tw-rounded tw-bg-iron-800" /><div className="tw-w-3/4 tw-h-3 tw-rounded tw-bg-iron-800" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="tw-flex tw-flex-col tw-w-full tw-p-3 tw-gap-2 tw-border-b tw-border-iron-800">{t1}{t2}<div className="tw-flex tw-justify-between tw-mt-1"><div className="tw-w-20 tw-h-2 tw-rounded tw-bg-iron-800" /><div className="tw-w-12 tw-h-2 tw-rounded tw-bg-iron-800" /></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export default LightDrop;